export const translations = {
  en: {
    // Navigation
    home: "Home",
    books: "Books",
    videos: "Videos",
    search: "Search",
    profile: "Profile",
    login: "Login",
    register: "Register",
    logout: "Logout",
    subscription: "Subscription",
    upload: "Upload",
    chat: "Chat",
    admin: "Admin",

    // Home page
    discoverAmazingContent: "Discover Amazing Content",
    searchAndFilterDescription: "Search and filter through our collection of videos and books",
    searchPlaceholder: "Search by title, author, instructor, or description...",
    featuredVideos: "Featured Videos",
    featuredBooks: "Featured Books",
    viewAll: "View All",
    noVideosAvailable: "No videos available",
    noBooksAvailable: "No books available",
    readyToStartLearning: "Ready to Start Learning?",
    joinMillionsDescription: "Join millions of learners worldwide and unlock your potential with StreamFlow.",
    getStartedNow: "Get Started Now",
    by: "by",
    pages: "pages",
    readBook: "Read Book",
    watchVideo: "Watch Video",

    // Books page
    allBooks: "All Books",
    booksCount: "books",
    searchBooksPlaceholder: "Search books by title, author, or description...",
    filters: "Filters",
    allCategories: "All Categories",
    sortBy: "Sort by",
    title: "Title",
    author: "Author",
    rating: "Rating",
    clearAllFilters: "Clear All Filters",
    noBooksFound: "No books found",
    tryAdjustingSearch: "Try adjusting your search or filters",
    clearFilters: "Clear Filters",

    // Videos page
    allVideos: "All Videos",
    videosCount: "videos",
    searchVideosPlaceholder: "Search videos by title, instructor, or description...",
    instructor: "Instructor",
    duration: "Duration",
    views: "Views",
    noVideosFound: "No videos found",

    // Book Details page
    bookNotAvailable: "Book not available.",
    loading: "Loading...",

    // Profile page
    profileSettings: "Profile Settings",
    personalInformation: "Personal Information",
    displayName: "Display Name",
    email: "Email",
    phone: "Phone",
    location: "Location",
    saveChanges: "Save Changes",
    changesSaved: "Changes saved successfully!",
    errorSavingChanges: "Error saving changes. Please try again.",
    pleaseLogin: "Please log in to view your profile.",
    myVideos: "My Videos",
    myBooks: "My Books",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this item?",
    itemDeleted: "Item deleted successfully!",
    errorDeletingItem: "Error deleting item. Please try again.",
    public: "Public",
    private: "Private",

    // Auth pages
    emailAddress: "Email Address",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signUp: "Sign Up",
    signIn: "Sign In",
    resetPassword: "Reset Password",
    sendResetLink: "Send Reset Link",
    backToLogin: "Back to Login",
    privacyPolicyAgreement: "I agree to the Privacy Policy and Terms of Service. I will not upload nude or illegal content.",
    contentOwnershipAgreement: "I confirm that all information and content I provide is my own, can be made public for everyone (including children), and does not belong to anyone else.",
    welcomeBack: "Welcome Back",
    signInToContinue: "Sign in to continue to StreamFlow",
    enterYourEmail: "Enter your email",
    enterYourPassword: "Enter your password",
    signUpHere: "Sign up here",
    createAccount: "Create Account",
    joinStreamFlow: "Join StreamFlow and start your streaming journey",
    fullName: "Full Name",
    enterYourFullName: "Enter your full name",
    phoneNumberOptional: "Phone Number (Optional)",
    enterYourPhoneNumber: "Enter your phone number",
    locationOptional: "Location (Optional)",
    enterYourLocation: "Enter your location",
    createPassword: "Create a password",
    confirmYourPassword: "Confirm your password",
    signInHere: "Sign in here",

    // Subscription page
    subscriptionPlans: "Subscription Plans",
    freeSubscription: "Free Subscription",
    freeDescription: "Enjoy access to basic features at no cost. No credit card required.",
    accessToFreeContent: "Access to free books and videos",
    basicSupport: "Basic support",
    communityAccess: "Community access",
    currentPlan: "Current Plan",
    chooseFree: "Choose Free",

    // Upload page
    uploadContent: "Upload Content",
    uploadVideo: "Upload Video",
    uploadBook: "Upload Book",
    title: "Title",
    description: "Description",
    category: "Category",
    selectCategory: "Select Category",
    uploadFile: "Upload File",
    makePublic: "Make Public",
    submit: "Submit",
    uploadSuccess: "Upload successful!",
    uploadError: "Upload failed. Please try again.",

    // Common
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    loading: "Loading...",
    noData: "No data available",
    tryAgain: "Try Again",
    of: "of",
  },

  es: {
    // Navigation
    home: "Inicio",
    books: "Libros",
    videos: "Videos",
    search: "Buscar",
    profile: "Perfil",
    login: "Iniciar Sesión",
    register: "Registrarse",
    logout: "Cerrar Sesión",
    subscription: "Suscripción",
    upload: "Subir",
    chat: "Chat",
    admin: "Administrador",

    // Home page
    discoverAmazingContent: "Descubre Contenido Increíble",
    searchAndFilterDescription: "Busca y filtra a través de nuestra colección de videos y libros",
    searchPlaceholder: "Buscar por título, autor, instructor o descripción...",
    featuredVideos: "Videos Destacados",
    featuredBooks: "Libros Destacados",
    viewAll: "Ver Todo",
    noVideosAvailable: "No hay videos disponibles",
    noBooksAvailable: "No hay libros disponibles",
    readyToStartLearning: "¿Listo para Empezar a Aprender?",
    joinMillionsDescription: "Únete a millones de estudiantes en todo el mundo y desbloquea tu potencial con StreamFlow.",
    getStartedNow: "Comenzar Ahora",
    by: "por",
    pages: "páginas",
    readBook: "Leer Libro",
    watchVideo: "Ver Video",

    // Books page
    allBooks: "Todos los Libros",
    booksCount: "libros",
    searchBooksPlaceholder: "Buscar libros por título, autor o descripción...",
    filters: "Filtros",
    allCategories: "Todas las Categorías",
    sortBy: "Ordenar por",
    title: "Título",
    author: "Autor",
    rating: "Calificación",
    clearAllFilters: "Limpiar Todos los Filtros",
    noBooksFound: "No se encontraron libros",
    tryAdjustingSearch: "Intenta ajustar tu búsqueda o filtros",
    clearFilters: "Limpiar Filtros",

    // Videos page
    allVideos: "Todos los Videos",
    videosCount: "videos",
    searchVideosPlaceholder: "Buscar videos por título, instructor o descripción...",
    instructor: "Instructor",
    duration: "Duración",
    views: "Vistas",
    noVideosFound: "No se encontraron videos",

    // Book Details page
    bookNotAvailable: "Libro no disponible.",
    loading: "Cargando...",

    // Profile page
    profileSettings: "Configuración del Perfil",
    personalInformation: "Información Personal",
    displayName: "Nombre de Mostrar",
    email: "Correo Electrónico",
    phone: "Teléfono",
    location: "Ubicación",
    saveChanges: "Guardar Cambios",
    changesSaved: "¡Cambios guardados exitosamente!",
    errorSavingChanges: "Error al guardar cambios. Por favor intenta de nuevo.",
    pleaseLogin: "Por favor inicia sesión para ver tu perfil.",
    myVideos: "Mis Videos",
    myBooks: "Mis Libros",
    delete: "Eliminar",
    confirmDelete: "¿Estás seguro de que quieres eliminar este elemento?",
    itemDeleted: "¡Elemento eliminado exitosamente!",
    errorDeletingItem: "Error al eliminar elemento. Por favor intenta de nuevo.",
    public: "Público",
    private: "Privado",

    // Auth pages
    emailAddress: "Dirección de Correo",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    forgotPassword: "¿Olvidaste tu Contraseña?",
    dontHaveAccount: "¿No tienes una cuenta?",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    signUp: "Registrarse",
    signIn: "Iniciar Sesión",
    resetPassword: "Restablecer Contraseña",
    sendResetLink: "Enviar Enlace de Restablecimiento",
    backToLogin: "Volver al Inicio de Sesión",
    privacyPolicyAgreement: "Acepto la Política de Privacidad y los Términos de Servicio. No subiré contenido desnudo o ilegal.",
    contentOwnershipAgreement: "Confirmo que toda la información y contenido que proporciono es mío, puede hacerse público para todos (incluyendo niños), y no pertenece a nadie más.",
    welcomeBack: "Bienvenido de Vuelta",
    signInToContinue: "Inicia sesión para continuar en StreamFlow",
    enterYourEmail: "Ingresa tu correo electrónico",
    enterYourPassword: "Ingresa tu contraseña",
    signUpHere: "Regístrate aquí",
    createAccount: "Crear Cuenta",
    joinStreamFlow: "Únete a StreamFlow y comienza tu viaje de streaming",
    fullName: "Nombre Completo",
    enterYourFullName: "Ingresa tu nombre completo",
    phoneNumberOptional: "Número de Teléfono (Opcional)",
    enterYourPhoneNumber: "Ingresa tu número de teléfono",
    locationOptional: "Ubicación (Opcional)",
    enterYourLocation: "Ingresa tu ubicación",
    createPassword: "Crear una contraseña",
    confirmYourPassword: "Confirma tu contraseña",
    signInHere: "Inicia sesión aquí",

    // Subscription page
    subscriptionPlans: "Planes de Suscripción",
    freeSubscription: "Suscripción Gratuita",
    freeDescription: "Disfruta acceso a funciones básicas sin costo. No se requiere tarjeta de crédito.",
    accessToFreeContent: "Acceso a libros y videos gratuitos",
    basicSupport: "Soporte básico",
    communityAccess: "Acceso a la comunidad",
    currentPlan: "Plan Actual",
    chooseFree: "Elegir Gratis",

    // Upload page
    uploadContent: "Subir Contenido",
    uploadVideo: "Subir Video",
    uploadBook: "Subir Libro",
    title: "Título",
    description: "Descripción",
    category: "Categoría",
    selectCategory: "Seleccionar Categoría",
    uploadFile: "Subir Archivo",
    makePublic: "Hacer Público",
    submit: "Enviar",
    uploadSuccess: "¡Subida exitosa!",
    uploadError: "Error en la subida. Por favor intenta de nuevo.",

    // Common
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Guardar",
    edit: "Editar",
    delete: "Eliminar",
    close: "Cerrar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    submit: "Enviar",
    loading: "Cargando...",
    noData: "No hay datos disponibles",
    tryAgain: "Intentar de Nuevo",
    of: "de",
  },

  fr: {
    // Navigation
    home: "Accueil",
    books: "Livres",
    videos: "Vidéos",
    search: "Rechercher",
    profile: "Profil",
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    subscription: "Abonnement",
    upload: "Télécharger",
    chat: "Chat",
    admin: "Administrateur",

    // Home page
    discoverAmazingContent: "Découvrez du Contenu Incroyable",
    searchAndFilterDescription: "Recherchez et filtrez dans notre collection de vidéos et de livres",
    searchPlaceholder: "Rechercher par titre, auteur, instructeur ou description...",
    featuredVideos: "Vidéos en Vedette",
    featuredBooks: "Livres en Vedette",
    viewAll: "Voir Tout",
    noVideosAvailable: "Aucune vidéo disponible",
    noBooksAvailable: "Aucun livre disponible",
    readyToStartLearning: "Prêt à Commencer à Apprendre?",
    joinMillionsDescription: "Rejoignez des millions d'apprenants dans le monde et libérez votre potentiel avec StreamFlow.",
    getStartedNow: "Commencer Maintenant",
    by: "par",
    pages: "pages",
    readBook: "Lire le Livre",
    watchVideo: "Regarder la Vidéo",

    // Books page
    allBooks: "Tous les Livres",
    booksCount: "livres",
    searchBooksPlaceholder: "Rechercher des livres par titre, auteur ou description...",
    filters: "Filtres",
    allCategories: "Toutes les Catégories",
    sortBy: "Trier par",
    title: "Titre",
    author: "Auteur",
    rating: "Note",
    clearAllFilters: "Effacer Tous les Filtres",
    noBooksFound: "Aucun livre trouvé",
    tryAdjustingSearch: "Essayez d'ajuster votre recherche ou vos filtres",
    clearFilters: "Effacer les Filtres",

    // Videos page
    allVideos: "Toutes les Vidéos",
    videosCount: "vidéos",
    searchVideosPlaceholder: "Rechercher des vidéos par titre, instructeur ou description...",
    instructor: "Instructeur",
    duration: "Durée",
    views: "Vues",
    noVideosFound: "Aucune vidéo trouvée",

    // Book Details page
    bookNotAvailable: "Livre non disponible.",
    loading: "Chargement...",

    // Profile page
    profileSettings: "Paramètres du Profil",
    personalInformation: "Informations Personnelles",
    displayName: "Nom d'Affichage",
    email: "E-mail",
    phone: "Téléphone",
    location: "Localisation",
    saveChanges: "Enregistrer les Modifications",
    changesSaved: "Modifications enregistrées avec succès!",
    errorSavingChanges: "Erreur lors de l'enregistrement des modifications. Veuillez réessayer.",
    pleaseLogin: "Veuillez vous connecter pour voir votre profil.",
    myVideos: "Mes Vidéos",
    myBooks: "Mes Livres",
    delete: "Supprimer",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet élément?",
    itemDeleted: "Élément supprimé avec succès!",
    errorDeletingItem: "Erreur lors de la suppression de l'élément. Veuillez réessayer.",
    public: "Public",
    private: "Privé",

    // Auth pages
    emailAddress: "Adresse E-mail",
    password: "Mot de Passe",
    confirmPassword: "Confirmer le Mot de Passe",
    forgotPassword: "Mot de Passe Oublié?",
    dontHaveAccount: "Vous n'avez pas de compte?",
    alreadyHaveAccount: "Vous avez déjà un compte?",
    signUp: "S'inscrire",
    signIn: "Se Connecter",
    resetPassword: "Réinitialiser le Mot de Passe",
    sendResetLink: "Envoyer le Lien de Réinitialisation",
    backToLogin: "Retour à la Connexion",
    privacyPolicyAgreement: "J'accepte la Politique de Confidentialité et les Conditions de Service. Je ne téléchargerai pas de contenu nu ou illégal.",
    contentOwnershipAgreement: "Je confirme que toutes les informations et le contenu que je fournis sont les miens, peuvent être rendus publics pour tout le monde (y compris les enfants), et n'appartiennent à personne d'autre.",
    welcomeBack: "Bon Retour",
    signInToContinue: "Connectez-vous pour continuer sur StreamFlow",
    enterYourEmail: "Entrez votre e-mail",
    enterYourPassword: "Entrez votre mot de passe",
    signUpHere: "Inscrivez-vous ici",
    createAccount: "Créer un Compte",
    joinStreamFlow: "Rejoignez StreamFlow et commencez votre voyage de streaming",
    fullName: "Nom Complet",
    enterYourFullName: "Entrez votre nom complet",
    phoneNumberOptional: "Numéro de Téléphone (Optionnel)",
    enterYourPhoneNumber: "Entrez votre numéro de téléphone",
    locationOptional: "Localisation (Optionnelle)",
    enterYourLocation: "Entrez votre localisation",
    createPassword: "Créer un mot de passe",
    confirmYourPassword: "Confirmez votre mot de passe",
    signInHere: "Connectez-vous ici",

    // Subscription page
    subscriptionPlans: "Plans d'Abonnement",
    freeSubscription: "Abonnement Gratuit",
    freeDescription: "Profitez de l'accès aux fonctionnalités de base sans frais. Aucune carte de crédit requise.",
    accessToFreeContent: "Accès aux livres et vidéos gratuits",
    basicSupport: "Support de base",
    communityAccess: "Accès à la communauté",
    currentPlan: "Plan Actuel",
    chooseFree: "Choisir Gratuit",

    // Upload page
    uploadContent: "Télécharger du Contenu",
    uploadVideo: "Télécharger une Vidéo",
    uploadBook: "Télécharger un Livre",
    title: "Titre",
    description: "Description",
    category: "Catégorie",
    selectCategory: "Sélectionner une Catégorie",
    uploadFile: "Télécharger un Fichier",
    makePublic: "Rendre Public",
    submit: "Soumettre",
    uploadSuccess: "Téléchargement réussi!",
    uploadError: "Échec du téléchargement. Veuillez réessayer.",

    // Common
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    confirm: "Confirmer",
    save: "Enregistrer",
    edit: "Modifier",
    delete: "Supprimer",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    submit: "Soumettre",
    loading: "Chargement...",
    noData: "Aucune donnée disponible",
    tryAgain: "Réessayer",
    of: "sur",
  },

  de: {
    // Navigation
    home: "Startseite",
    books: "Bücher",
    videos: "Videos",
    search: "Suchen",
    profile: "Profil",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    subscription: "Abonnement",
    upload: "Hochladen",
    chat: "Chat",
    admin: "Administrator",

    // Home page
    discoverAmazingContent: "Entdecke Erstaunliche Inhalte",
    searchAndFilterDescription: "Durchsuche und filtere unsere Sammlung von Videos und Büchern",
    searchPlaceholder: "Suche nach Titel, Autor, Dozent oder Beschreibung...",
    featuredVideos: "Empfohlene Videos",
    featuredBooks: "Empfohlene Bücher",
    viewAll: "Alle Anzeigen",
    noVideosAvailable: "Keine Videos verfügbar",
    noBooksAvailable: "Keine Bücher verfügbar",
    readyToStartLearning: "Bereit zum Lernen?",
    joinMillionsDescription: "Schließe dich Millionen von Lernenden weltweit an und entfalte dein Potenzial mit StreamFlow.",
    getStartedNow: "Jetzt Beginnen",
    by: "von",
    pages: "Seiten",
    readBook: "Buch Lesen",
    watchVideo: "Video Ansehen",

    // Books page
    allBooks: "Alle Bücher",
    booksCount: "Bücher",
    searchBooksPlaceholder: "Suche Bücher nach Titel, Autor oder Beschreibung...",
    filters: "Filter",
    allCategories: "Alle Kategorien",
    sortBy: "Sortieren nach",
    title: "Titel",
    author: "Autor",
    rating: "Bewertung",
    clearAllFilters: "Alle Filter Löschen",
    noBooksFound: "Keine Bücher gefunden",
    tryAdjustingSearch: "Versuche deine Suche oder Filter anzupassen",
    clearFilters: "Filter Löschen",

    // Videos page
    allVideos: "Alle Videos",
    videosCount: "Videos",
    searchVideosPlaceholder: "Suche Videos nach Titel, Dozent oder Beschreibung...",
    instructor: "Dozent",
    duration: "Dauer",
    views: "Aufrufe",
    noVideosFound: "Keine Videos gefunden",

    // Book Details page
    bookNotAvailable: "Buch nicht verfügbar.",
    loading: "Lädt...",

    // Profile page
    profileSettings: "Profileinstellungen",
    personalInformation: "Persönliche Informationen",
    displayName: "Anzeigename",
    email: "E-Mail",
    phone: "Telefon",
    location: "Standort",
    saveChanges: "Änderungen Speichern",
    changesSaved: "Änderungen erfolgreich gespeichert!",
    errorSavingChanges: "Fehler beim Speichern der Änderungen. Bitte versuche es erneut.",
    pleaseLogin: "Bitte melde dich an, um dein Profil zu sehen.",
    myVideos: "Meine Videos",
    myBooks: "Meine Bücher",
    delete: "Löschen",
    confirmDelete: "Bist du sicher, dass du dieses Element löschen möchtest?",
    itemDeleted: "Element erfolgreich gelöscht!",
    errorDeletingItem: "Fehler beim Löschen des Elements. Bitte versuche es erneut.",
    public: "Öffentlich",
    private: "Privat",

    // Auth pages
    emailAddress: "E-Mail-Adresse",
    password: "Passwort",
    confirmPassword: "Passwort Bestätigen",
    forgotPassword: "Passwort Vergessen?",
    dontHaveAccount: "Hast du kein Konto?",
    alreadyHaveAccount: "Hast du bereits ein Konto?",
    signUp: "Registrieren",
    signIn: "Anmelden",
    resetPassword: "Passwort Zurücksetzen",
    sendResetLink: "Zurücksetzen-Link Senden",
    backToLogin: "Zurück zur Anmeldung",
    privacyPolicyAgreement: "Ich stimme der Datenschutzerklärung und den Nutzungsbedingungen zu. Ich werde keine nackten oder illegalen Inhalte hochladen.",
    contentOwnershipAgreement: "Ich bestätige, dass alle Informationen und Inhalte, die ich bereitstelle, meine eigenen sind, für alle öffentlich gemacht werden können (einschließlich Kinder), und niemand anderem gehören.",
    welcomeBack: "Willkommen Zurück",
    signInToContinue: "Melde dich an, um bei StreamFlow fortzufahren",
    enterYourEmail: "Gib deine E-Mail-Adresse ein",
    enterYourPassword: "Gib dein Passwort ein",
    signUpHere: "Hier registrieren",
    createAccount: "Konto Erstellen",
    joinStreamFlow: "Tritt StreamFlow bei und beginne deine Streaming-Reise",
    fullName: "Vollständiger Name",
    enterYourFullName: "Gib deinen vollständigen Namen ein",
    phoneNumberOptional: "Telefonnummer (Optional)",
    enterYourPhoneNumber: "Gib deine Telefonnummer ein",
    locationOptional: "Standort (Optional)",
    enterYourLocation: "Gib deinen Standort ein",
    createPassword: "Passwort erstellen",
    confirmYourPassword: "Passwort bestätigen",
    signInHere: "Hier anmelden",

    // Subscription page
    subscriptionPlans: "Abonnement-Pläne",
    freeSubscription: "Kostenloses Abonnement",
    freeDescription: "Genieße Zugang zu grundlegenden Funktionen ohne Kosten. Keine Kreditkarte erforderlich.",
    accessToFreeContent: "Zugang zu kostenlosen Büchern und Videos",
    basicSupport: "Grundlegender Support",
    communityAccess: "Community-Zugang",
    currentPlan: "Aktueller Plan",
    chooseFree: "Kostenlos Wählen",

    // Upload page
    uploadContent: "Inhalt Hochladen",
    uploadVideo: "Video Hochladen",
    uploadBook: "Buch Hochladen",
    title: "Titel",
    description: "Beschreibung",
    category: "Kategorie",
    selectCategory: "Kategorie Auswählen",
    uploadFile: "Datei Hochladen",
    makePublic: "Öffentlich Machen",
    submit: "Absenden",
    uploadSuccess: "Hochladen erfolgreich!",
    uploadError: "Hochladen fehlgeschlagen. Bitte versuche es erneut.",

    // Common
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    save: "Speichern",
    edit: "Bearbeiten",
    delete: "Löschen",
    close: "Schließen",
    back: "Zurück",
    next: "Weiter",
    previous: "Zurück",
    submit: "Absenden",
    loading: "Lädt...",
    noData: "Keine Daten verfügbar",
    tryAgain: "Erneut Versuchen",
    of: "von",
  },

  ar: {
    // Navigation
    home: "الرئيسية",
    books: "الكتب",
    videos: "الفيديوهات",
    search: "البحث",
    profile: "الملف الشخصي",
    login: "تسجيل الدخول",
    register: "التسجيل",
    logout: "تسجيل الخروج",
    subscription: "الاشتراك",
    upload: "رفع",
    chat: "الدردشة",
    admin: "المدير",

    // Home page
    discoverAmazingContent: "اكتشف محتوى مذهل",
    searchAndFilterDescription: "ابحث وفلتر في مجموعتنا من الفيديوهات والكتب",
    searchPlaceholder: "ابحث بالعنوان، المؤلف، المدرب أو الوصف...",
    featuredVideos: "الفيديوهات المميزة",
    featuredBooks: "الكتب المميزة",
    viewAll: "عرض الكل",
    noVideosAvailable: "لا توجد فيديوهات متاحة",
    noBooksAvailable: "لا توجد كتب متاحة",
    readyToStartLearning: "مستعد للبدء في التعلم؟",
    joinMillionsDescription: "انضم إلى ملايين المتعلمين حول العالم واطلق إمكانياتك مع StreamFlow.",
    getStartedNow: "ابدأ الآن",
    by: "بواسطة",
    pages: "صفحات",
    readBook: "اقرأ الكتاب",
    watchVideo: "شاهد الفيديو",

    // Books page
    allBooks: "جميع الكتب",
    booksCount: "كتب",
    searchBooksPlaceholder: "ابحث في الكتب بالعنوان، المؤلف أو الوصف...",
    filters: "المرشحات",
    allCategories: "جميع الفئات",
    sortBy: "ترتيب حسب",
    title: "العنوان",
    author: "المؤلف",
    rating: "التقييم",
    clearAllFilters: "مسح جميع المرشحات",
    noBooksFound: "لم يتم العثور على كتب",
    tryAdjustingSearch: "حاول تعديل بحثك أو مرشحاتك",
    clearFilters: "مسح المرشحات",

    // Videos page
    allVideos: "جميع الفيديوهات",
    videosCount: "فيديوهات",
    searchVideosPlaceholder: "ابحث في الفيديوهات بالعنوان، المدرب أو الوصف...",
    instructor: "المدرب",
    duration: "المدة",
    views: "المشاهدات",
    noVideosFound: "لم يتم العثور على فيديوهات",

    // Book Details page
    bookNotAvailable: "الكتاب غير متاح.",
    loading: "جاري التحميل...",

    // Profile page
    profileSettings: "إعدادات الملف الشخصي",
    personalInformation: "المعلومات الشخصية",
    displayName: "اسم العرض",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    location: "الموقع",
    saveChanges: "حفظ التغييرات",
    changesSaved: "تم حفظ التغييرات بنجاح!",
    errorSavingChanges: "خطأ في حفظ التغييرات. يرجى المحاولة مرة أخرى.",
    pleaseLogin: "يرجى تسجيل الدخول لعرض ملفك الشخصي.",
    myVideos: "فيديوهاتي",
    myBooks: "كتبي",
    delete: "حذف",
    confirmDelete: "هل أنت متأكد من أنك تريد حذف هذا العنصر؟",
    itemDeleted: "تم حذف العنصر بنجاح!",
    errorDeletingItem: "خطأ في حذف العنصر. يرجى المحاولة مرة أخرى.",
    public: "عام",
    private: "خاص",

    // Auth pages
    emailAddress: "عنوان البريد الإلكتروني",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    dontHaveAccount: "ليس لديك حساب؟",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    signUp: "التسجيل",
    signIn: "تسجيل الدخول",
    resetPassword: "إعادة تعيين كلمة المرور",
    sendResetLink: "إرسال رابط إعادة التعيين",
    backToLogin: "العودة لتسجيل الدخول",
    privacyPolicyAgreement: "أوافق على سياسة الخصوصية وشروط الخدمة. لن أرفع محتوى عاري أو غير قانوني.",
    contentOwnershipAgreement: "أؤكد أن جميع المعلومات والمحتوى الذي أقدمه هو ملكي، يمكن أن يكون متاحاً للجميع (بما في ذلك الأطفال)، ولا ينتمي لأي شخص آخر.",
    welcomeBack: "مرحباً بعودتك",
    signInToContinue: "سجل دخولك للاستمرار في StreamFlow",
    enterYourEmail: "أدخل بريدك الإلكتروني",
    enterYourPassword: "أدخل كلمة المرور",
    signUpHere: "سجل هنا",
    createAccount: "إنشاء حساب",
    joinStreamFlow: "انضم إلى StreamFlow وابدأ رحلة البث الخاصة بك",
    fullName: "الاسم الكامل",
    enterYourFullName: "أدخل اسمك الكامل",
    phoneNumberOptional: "رقم الهاتف (اختياري)",
    enterYourPhoneNumber: "أدخل رقم هاتفك",
    locationOptional: "الموقع (اختياري)",
    enterYourLocation: "أدخل موقعك",
    createPassword: "إنشاء كلمة مرور",
    confirmYourPassword: "تأكيد كلمة المرور",
    signInHere: "سجل دخولك هنا",

    // Subscription page
    subscriptionPlans: "خطط الاشتراك",
    freeSubscription: "الاشتراك المجاني",
    freeDescription: "استمتع بالوصول إلى الميزات الأساسية بدون تكلفة. لا توجد بطاقة ائتمان مطلوبة.",
    accessToFreeContent: "الوصول إلى الكتب والفيديوهات المجانية",
    basicSupport: "الدعم الأساسي",
    communityAccess: "الوصول إلى المجتمع",
    currentPlan: "الخطة الحالية",
    chooseFree: "اختر المجاني",

    // Upload page
    uploadContent: "رفع المحتوى",
    uploadVideo: "رفع فيديو",
    uploadBook: "رفع كتاب",
    title: "العنوان",
    description: "الوصف",
    category: "الفئة",
    selectCategory: "اختر الفئة",
    uploadFile: "رفع ملف",
    makePublic: "جعله عاماً",
    submit: "إرسال",
    uploadSuccess: "تم الرفع بنجاح!",
    uploadError: "فشل الرفع. يرجى المحاولة مرة أخرى.",

    // Common
    error: "خطأ",
    success: "نجح",
    cancel: "إلغاء",
    confirm: "تأكيد",
    save: "حفظ",
    edit: "تعديل",
    delete: "حذف",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    submit: "إرسال",
    loading: "جاري التحميل...",
    noData: "لا توجد بيانات متاحة",
    tryAgain: "حاول مرة أخرى",
    of: "من",
  },

  zh: {
    // Navigation
    home: "首页",
    books: "书籍",
    videos: "视频",
    search: "搜索",
    profile: "个人资料",
    login: "登录",
    register: "注册",
    logout: "退出登录",
    subscription: "订阅",
    upload: "上传",
    chat: "聊天",
    admin: "管理员",

    // Home page
    discoverAmazingContent: "发现精彩内容",
    searchAndFilterDescription: "搜索和筛选我们的视频和书籍收藏",
    searchPlaceholder: "按标题、作者、讲师或描述搜索...",
    featuredVideos: "精选视频",
    featuredBooks: "精选书籍",
    viewAll: "查看全部",
    noVideosAvailable: "暂无视频",
    noBooksAvailable: "暂无书籍",
    readyToStartLearning: "准备开始学习？",
    joinMillionsDescription: "加入全球数百万学习者，通过StreamFlow释放您的潜力。",
    getStartedNow: "立即开始",
    by: "作者",
    pages: "页",
    readBook: "阅读书籍",
    watchVideo: "观看视频",

    // Books page
    allBooks: "所有书籍",
    booksCount: "本书",
    searchBooksPlaceholder: "按标题、作者或描述搜索书籍...",
    filters: "筛选",
    allCategories: "所有分类",
    sortBy: "排序方式",
    title: "标题",
    author: "作者",
    rating: "评分",
    clearAllFilters: "清除所有筛选",
    noBooksFound: "未找到书籍",
    tryAdjustingSearch: "请尝试调整搜索或筛选条件",
    clearFilters: "清除筛选",

    // Videos page
    allVideos: "所有视频",
    videosCount: "个视频",
    searchVideosPlaceholder: "按标题、讲师或描述搜索视频...",
    instructor: "讲师",
    duration: "时长",
    views: "观看次数",
    noVideosFound: "未找到视频",

    // Book Details page
    bookNotAvailable: "书籍不可用。",
    loading: "加载中...",

    // Profile page
    profileSettings: "个人资料设置",
    personalInformation: "个人信息",
    displayName: "显示名称",
    email: "电子邮件",
    phone: "电话",
    location: "位置",
    saveChanges: "保存更改",
    changesSaved: "更改保存成功！",
    errorSavingChanges: "保存更改时出错。请重试。",
    pleaseLogin: "请登录以查看您的个人资料。",
    myVideos: "我的视频",
    myBooks: "我的书籍",
    delete: "删除",
    confirmDelete: "您确定要删除此项目吗？",
    itemDeleted: "项目删除成功！",
    errorDeletingItem: "删除项目时出错。请重试。",
    public: "公开",
    private: "私密",

    // Auth pages
    emailAddress: "电子邮件地址",
    password: "密码",
    confirmPassword: "确认密码",
    forgotPassword: "忘记密码？",
    dontHaveAccount: "没有账户？",
    alreadyHaveAccount: "已有账户？",
    signUp: "注册",
    signIn: "登录",
    resetPassword: "重置密码",
    sendResetLink: "发送重置链接",
    backToLogin: "返回登录",
    privacyPolicyAgreement: "我同意隐私政策和服务条款。我不会上传裸体或非法内容。",
    contentOwnershipAgreement: "我确认我提供的所有信息和内容都是我自己的，可以公开给所有人（包括儿童），不属于任何其他人。",
    welcomeBack: "欢迎回来",
    signInToContinue: "登录以继续使用 StreamFlow",
    enterYourEmail: "输入您的电子邮件",
    enterYourPassword: "输入您的密码",
    signUpHere: "在此注册",
    createAccount: "创建账户",
    joinStreamFlow: "加入 StreamFlow 并开始您的流媒体之旅",
    fullName: "全名",
    enterYourFullName: "输入您的全名",
    phoneNumberOptional: "电话号码（可选）",
    enterYourPhoneNumber: "输入您的电话号码",
    locationOptional: "位置（可选）",
    enterYourLocation: "输入您的位置",
    createPassword: "创建密码",
    confirmYourPassword: "确认您的密码",
    signInHere: "在此登录",

    // Subscription page
    subscriptionPlans: "订阅计划",
    freeSubscription: "免费订阅",
    freeDescription: "享受基本功能的免费访问。无需信用卡。",
    accessToFreeContent: "访问免费书籍和视频",
    basicSupport: "基本支持",
    communityAccess: "社区访问",
    currentPlan: "当前计划",
    chooseFree: "选择免费",

    // Upload page
    uploadContent: "上传内容",
    uploadVideo: "上传视频",
    uploadBook: "上传书籍",
    title: "标题",
    description: "描述",
    category: "分类",
    selectCategory: "选择分类",
    uploadFile: "上传文件",
    makePublic: "设为公开",
    submit: "提交",
    uploadSuccess: "上传成功！",
    uploadError: "上传失败。请重试。",

    // Common
    error: "错误",
    success: "成功",
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    edit: "编辑",
    delete: "删除",
    close: "关闭",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    submit: "提交",
    loading: "加载中...",
    noData: "暂无数据",
    tryAgain: "重试",
    of: "共",
  },

  fa: {
    // Navigation
    home: "خانه",
    books: "کتاب‌ها",
    videos: "ویدیوها",
    search: "جستجو",
    profile: "پروفایل",
    login: "ورود",
    register: "ثبت‌نام",
    logout: "خروج",
    subscription: "اشتراک",
    upload: "آپلود",
    chat: "چت",
    admin: "مدیر",

    // Home page
    discoverAmazingContent: "محتوای شگفت‌انگیز را کشف کنید",
    searchAndFilterDescription: "در مجموعه ویدیوها و کتاب‌های ما جستجو و فیلتر کنید",
    searchPlaceholder: "بر اساس عنوان، نویسنده، مدرس یا توضیحات جستجو کنید...",
    featuredVideos: "ویدیوهای ویژه",
    featuredBooks: "کتاب‌های ویژه",
    viewAll: "مشاهده همه",
    noVideosAvailable: "هیچ ویدیویی موجود نیست",
    noBooksAvailable: "هیچ کتابی موجود نیست",
    readyToStartLearning: "آماده شروع یادگیری هستید؟",
    joinMillionsDescription: "به میلیون‌ها یادگیرنده در سراسر جهان بپیوندید و پتانسیل خود را با StreamFlow آزاد کنید.",
    getStartedNow: "همین حالا شروع کنید",
    by: "نویسنده",
    pages: "صفحه",
    readBook: "خواندن کتاب",
    watchVideo: "مشاهده ویدیو",

    // Books page
    allBooks: "همه کتاب‌ها",
    booksCount: "کتاب",
    searchBooksPlaceholder: "کتاب‌ها را بر اساس عنوان، نویسنده یا توضیحات جستجو کنید...",
    filters: "فیلترها",
    allCategories: "همه دسته‌بندی‌ها",
    sortBy: "مرتب‌سازی بر اساس",
    title: "عنوان",
    author: "نویسنده",
    rating: "امتیاز",
    clearAllFilters: "پاک کردن همه فیلترها",
    noBooksFound: "هیچ کتابی یافت نشد",
    tryAdjustingSearch: "سعی کنید جستجو یا فیلترهای خود را تنظیم کنید",
    clearFilters: "پاک کردن فیلترها",

    // Videos page
    allVideos: "همه ویدیوها",
    videosCount: "ویدیو",
    searchVideosPlaceholder: "ویدیوها را بر اساس عنوان، مدرس یا توضیحات جستجو کنید...",
    instructor: "مدرس",
    duration: "مدت زمان",
    views: "بازدید",
    noVideosFound: "هیچ ویدیویی یافت نشد",

    // Book Details page
    bookNotAvailable: "کتاب در دسترس نیست.",
    loading: "در حال بارگذاری...",

    // Profile page
    profileSettings: "تنظیمات پروفایل",
    personalInformation: "اطلاعات شخصی",
    displayName: "نام نمایشی",
    email: "ایمیل",
    phone: "تلفن",
    location: "موقعیت",
    saveChanges: "ذخیره تغییرات",
    changesSaved: "تغییرات با موفقیت ذخیره شد!",
    errorSavingChanges: "خطا در ذخیره تغییرات. لطفاً دوباره تلاش کنید.",
    pleaseLogin: "لطفاً برای مشاهده پروفایل خود وارد شوید.",
    myVideos: "ویدیوهای من",
    myBooks: "کتاب‌های من",
    delete: "حذف",
    confirmDelete: "آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟",
    itemDeleted: "مورد با موفقیت حذف شد!",
    errorDeletingItem: "خطا در حذف مورد. لطفاً دوباره تلاش کنید.",
    public: "عمومی",
    private: "خصوصی",

    // Auth pages
    emailAddress: "آدرس ایمیل",
    password: "رمز عبور",
    confirmPassword: "تأیید رمز عبور",
    forgotPassword: "رمز عبور را فراموش کرده‌اید؟",
    dontHaveAccount: "حساب کاربری ندارید؟",
    alreadyHaveAccount: "قبلاً حساب کاربری دارید؟",
    signUp: "ثبت‌نام",
    signIn: "ورود",
    resetPassword: "بازنشانی رمز عبور",
    sendResetLink: "ارسال لینک بازنشانی",
    backToLogin: "بازگشت به ورود",
    privacyPolicyAgreement: "من با سیاست حریم خصوصی و شرایط خدمات موافقت می‌کنم. من محتوای برهنه یا غیرقانونی آپلود نخواهم کرد.",
    contentOwnershipAgreement: "تأیید می‌کنم که تمام اطلاعات و محتوایی که ارائه می‌دهم متعلق به خودم است، می‌تواند برای همه (از جمله کودکان) عمومی شود و متعلق به هیچ شخص دیگری نیست.",
    welcomeBack: "خوش برگشتی",
    signInToContinue: "برای ادامه در StreamFlow وارد شوید",
    enterYourEmail: "ایمیل خود را وارد کنید",
    enterYourPassword: "رمز عبور خود را وارد کنید",
    signUpHere: "اینجا ثبت‌نام کنید",
    createAccount: "ایجاد حساب کاربری",
    joinStreamFlow: "به StreamFlow بپیوندید و سفر استریمینگ خود را شروع کنید",
    fullName: "نام کامل",
    enterYourFullName: "نام کامل خود را وارد کنید",
    phoneNumberOptional: "شماره تلفن (اختیاری)",
    enterYourPhoneNumber: "شماره تلفن خود را وارد کنید",
    locationOptional: "موقعیت (اختیاری)",
    enterYourLocation: "موقعیت خود را وارد کنید",
    createPassword: "ایجاد رمز عبور",
    confirmYourPassword: "رمز عبور خود را تأیید کنید",
    signInHere: "اینجا وارد شوید",

    // Subscription page
    subscriptionPlans: "طرح‌های اشتراک",
    freeSubscription: "اشتراک رایگان",
    freeDescription: "از دسترسی رایگان به ویژگی‌های اساسی لذت ببرید. کارت اعتباری لازم نیست.",
    accessToFreeContent: "دسترسی به کتاب‌ها و ویدیوهای رایگان",
    basicSupport: "پشتیبانی اساسی",
    communityAccess: "دسترسی به جامعه",
    currentPlan: "طرح فعلی",
    chooseFree: "انتخاب رایگان",

    // Upload page
    uploadContent: "آپلود محتوا",
    uploadVideo: "آپلود ویدیو",
    uploadBook: "آپلود کتاب",
    title: "عنوان",
    description: "توضیحات",
    category: "دسته‌بندی",
    selectCategory: "انتخاب دسته‌بندی",
    uploadFile: "آپلود فایل",
    makePublic: "عمومی کردن",
    submit: "ارسال",
    uploadSuccess: "آپلود موفق!",
    uploadError: "آپلود ناموفق. لطفاً دوباره تلاش کنید.",

    // Common
    error: "خطا",
    success: "موفقیت",
    cancel: "لغو",
    confirm: "تأیید",
    save: "ذخیره",
    edit: "ویرایش",
    delete: "حذف",
    close: "بستن",
    back: "بازگشت",
    next: "بعدی",
    previous: "قبلی",
    submit: "ارسال",
    loading: "در حال بارگذاری...",
    noData: "داده‌ای موجود نیست",
    tryAgain: "دوباره تلاش کنید",
    of: "از",
  }
}; 